import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { SocioQsaResponse } from '@interfaces/corporate-registry/responses/empresa-cadastral.response';
import { VaultDatePipe } from '@shared/pipes/vault-date.pipe';
import { formatarDocumentoSocio } from '@shared/components/ownership-network/registry-formatters';

/**
 * "Sócios (N)" — o QSA da Receita, na tabela do Dossiê.
 *
 * Sem % de participação: a RF não informa esse dado, e a tela não o inventa. Sem o link
 * "Empresas do sócio →" do Dossiê: ele leva a uma busca que o Vault não tem.
 */
@Component({
  selector: 'app-registry-partners-card',
  standalone: true,
  imports: [CommonModule, VaultDatePipe],
  templateUrl: './registry-partners-card.component.html',
  styleUrl: './registry-partners-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryPartnersCardComponent {
  readonly socios = input.required<SocioQsaResponse[]>();

  /** Acordeão: começa aberto; o título recolhe e expande (pedido de 25/09/2026, card 2986). */
  protected readonly aberto = signal(true);
  protected readonly documento = formatarDocumentoSocio;
}
